import React from 'react'
import {Button} from 'reactstrap'

const FooterButtons = ({
    phase,
    onCancel,
    onSubmit,
    onAdd,
    canSubmit,
    canAdd,
}) => {
    if (phase === 'loading') {
        return (
            <>
                <Button className="btn-cancel-disabled" disabled>
                    Cancel
                </Button>
                <Button className="btn-primary-loading" disabled>
                    Generate background
                </Button>
            </>
        )
    }

    return (
        <>
            <Button color="btn btn-outline-secondary" outline onClick={onCancel}>
                Cancel
            </Button>
            {phase === 'input' && (
                <Button color="btn btn-primary" onClick={onSubmit} disabled={!canSubmit}>
                    Generate background
                </Button>
            )}
            {phase === 'done' && (
                <Button color="btn btn-primary" onClick={onAdd} disabled={!canAdd}>
                    Add background
                </Button>
            )}
        </>
    )
}

export default FooterButtons


